export const UPLOAD_METHODS = {
  BARCODE: 'barcode',
  IMAGE_AI: 'image_ai',
} as const;

export type UploadMethod = (typeof UPLOAD_METHODS)[keyof typeof UPLOAD_METHODS];

export type ProductUploadTags = Record<string, string>;

export type UploadMethodTags = {
  method: UploadMethod;
  success: 'true' | 'false';
};

export type UploadMethodDurationTags = UploadMethodTags;

export type UploadCompletedTags = {
  method: UploadMethod;
  outcome?: 'completed';
};

export const METHODS_SUMMARY = {
  BARCODE_ONLY: 'barcode_only',
  IMAGE_ONLY: 'image_only',
  BOTH: 'both',
} as const;

export type MethodsSummary = (typeof METHODS_SUMMARY)[keyof typeof METHODS_SUMMARY];

export type UploadMethodsSummaryTags = {
  methods_summary: MethodsSummary;
};

export type UploadSignedUrlRetryTags = {
  attempt: string;
};